export default function Contact() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            欢迎投稿爆料、商务合作或提出宝贵建议
          </p>
        </div>

        <div className="bg-white rounded-2xl p-6 md:p-8 border border-background-200/60">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
            <div className="text-center p-4 rounded-xl bg-background-50">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-primary-50 flex items-center justify-center">
                <i className="ri-mail-line text-xl text-primary-600"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">内容投稿</h3>
              <p className="text-xs text-foreground-500 whitespace-nowrap">tips@heiliaozx.com</p>
            </div>
            <div className="text-center p-4 rounded-xl bg-background-50">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-accent-50 flex items-center justify-center">
                <i className="ri-briefcase-line text-xl text-accent-600"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">商务合作</h3>
              <p className="text-xs text-foreground-500 whitespace-nowrap">biz@heiliaozx.com</p>
            </div>
            <div className="text-center p-4 rounded-xl bg-background-50">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-secondary-50 flex items-center justify-center">
                <i className="ri-service-line text-xl text-secondary-600"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">用户反馈</h3>
              <p className="text-xs text-foreground-500 whitespace-nowrap">support@heiliaozx.com</p>
            </div>
          </div>

          <form className="flex flex-col gap-4" data-readdy-form="true">
            <div className="hp-bot">
              <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <input
                type="text"
                name="name"
                placeholder="您的称呼"
                className="px-4 py-3 text-sm rounded-xl border border-background-200 bg-background-50 focus:outline-none focus:border-primary-300 transition-colors"
              />
              <input
                type="email"
                name="email"
                placeholder="电子邮箱"
                className="px-4 py-3 text-sm rounded-xl border border-background-200 bg-background-50 focus:outline-none focus:border-primary-300 transition-colors"
              />
            </div>
            <textarea
              name="message"
              placeholder="请在此描述您的投稿内容或合作需求..."
              rows={4}
              maxLength={500}
              className="px-4 py-3 text-sm rounded-xl border border-background-200 bg-background-50 focus:outline-none focus:border-primary-300 transition-colors resize-none"
            ></textarea>
            <button
              type="button"
              className="w-full sm:w-auto self-center px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm rounded-full transition-colors cursor-pointer whitespace-nowrap"
            >
              发送消息
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}